import {
  AppSettingsAltTwoTone,
  BookOnlineTwoTone,
  CircleTwoTone,
  LayersTwoTone,
  WorkTwoTone,
} from "@mui/icons-material";
import { BsSpeedometer2 } from "react-icons/bs";
import Images from "./assets/Images";

const goEasyRoutes = [
  "/app",
  "/go-easy/app-bookings",
  "/go-easy/assistance-pricing",
  "/go-easy/manage-cars",
  "/go-easy/moving-vehicles",
  "/go-easy/driver-management",
  "/go-easy/car-bookings",
  "/go-easy/transit-bookings",
];

const mainRoutes = [
  "/home",
  "/freights",
  "/aboutPTN",
  "/our-leadership",
  "/our-vision-mission",
  "/our-history",
  "/logistic-solutions",
  "/industries-we-move",
  "/warehousing-distribution",
  "/fleet-management",
  "/last-mile-solution",
  "/insights",
  "/contact-us",
  "/careers",
];

const Navigation = [
  {
    label: "Dashboard",
    icon: <BsSpeedometer2 />,
    type: "",
    path: "/",
  },
  {
    label: "Pages",
    icon: <LayersTwoTone />,
    type: "",
    childPath: mainRoutes,
    children: [
      {
        label: "Home",
        icon: <CircleTwoTone />,
        path: "/home",
      },
      {
        label: "Freights",
        icon: <CircleTwoTone />,
        path: "/freights",
      },
      {
        label: "About PTN",
        icon: <CircleTwoTone />,
        path: "/aboutPTN",
      },
      {
        label: "Our Leadership",
        icon: <CircleTwoTone />,
        path: "/our-leadership",
      },
      {
        label: "Our Vision & Mission",
        icon: <CircleTwoTone />,
        path: "/our-vision-mission",
      },
      {
        label: "Our History",
        icon: <CircleTwoTone />,
        path: "/our-history",
      },
      {
        label: "Logistic Solutions",
        icon: <CircleTwoTone />,
        path: "/logistic-solutions",
      },
      {
        label: "Industries We Move",
        icon: <CircleTwoTone />,
        path: "/industries-we-move",
      },
      {
        label: "Warehouse & Distribution",
        icon: <CircleTwoTone />,
        path: "/warehousing-distribution",
      },
      {
        label: "Fleet Management Solutions",
        icon: <CircleTwoTone />,
        path: "/fleet-management",
      },
      {
        label: "Last Mile Solution",
        icon: <CircleTwoTone />,
        path: "/last-mile-solution",
      },
      {
        label: "Insights",
        icon: <CircleTwoTone />,
        path: "/insights",
      },
      {
        label: "Contact Us",
        icon: <CircleTwoTone />,
        path: "/contact-us",
      },
      {
        label: "Careers",
        icon: <WorkTwoTone />,
        path: "/careers",
      },
    ],
  },

  {
    label: "Bookings",
    icon: <BookOnlineTwoTone />,
    type: "",
    path: "/bookings",
  },
  {
    label: "Apps",
    icon: <AppSettingsAltTwoTone />,
    type: "",
    childPath: goEasyRoutes,
    children: [
      {
        label: "Go Easy",
        icon: <CircleTwoTone />,
        childPath: goEasyRoutes,
        children: [
          {
            label: "Bookings",
            icon: <CircleTwoTone />,
            path: "/go-easy/app-bookings",
          },
          {
            label: "Moving Vehicles",
            icon: <CircleTwoTone />,
            path: "/go-easy/moving-vehicles",
          },
          {
            label: "Manage Cars",
            icon: <CircleTwoTone />,
            path: "/go-easy/manage-cars",
          },
          {
            label: "Assistance Price",
            icon: <CircleTwoTone />,
            path: "/go-easy/assistance-pricing",
          },
          {
            label: "Driver Management",
            icon: <CircleTwoTone />,
            path: "/go-easy/driver-management",
          },
        ],
      },
      // {
      //   label: "PTN App",
      //   icon: <CircleTwoTone />,
      //   path: "/freights",
      // },
    ],
  },
  // {
  //   label: "Email",
  //   icon: <ForwardToInboxTwoTone />,
  //   type: "",
  //   path: "",
  // },
  {
    label: "Job Proposals",
    icon: <WorkTwoTone />,
    type: "",
    path: "/job-proposals",
  },
  {
    label: "Contact Us",
    icon: <WorkTwoTone />,
    type: "",
    path: "/contact-us-request",
  },
];
export default Navigation;

export const freightsNavigation = [
  {
    icon: Images.landFreightIcon,
    title: "Land Freight",
    link: "/land-freight",
  },
  {
    icon: Images.shipFreightIcon,
    title: "Sea Freight",
    link: "/sea-freight",
  },
  {
    icon: Images.crossBorderFreightIcon,
    title: "Cross Border Freight",
    link: "/crossborder-freight",
  },
  {
    icon: Images.airFreightIcon,
    title: "Air Freight",
    link: "/air-freight",
  },
  {
    icon: Images.railFreightIcon,
    title: "Rail Freight",
    link: "/rail-freight",
  },
];

export const freightsBookingsNavigation = [
  {
    icon: Images.landFreightIcon,
    title: "Land Freight Bookings",
    link: "/landfreight-bookings",
  },
  {
    icon: Images.shipFreightIcon,
    title: "Sea Freight Bookings",
    link: "/seafreight-bookings",
  },
  {
    icon: Images.crossBorderFreightIcon,
    title: "Warehouse Bookings",
    link: "/warehouse-bookings",
  },
  {
    icon: Images.airFreightIcon,
    title: "Vehicle Bookings",
    link: "/vehicle-bookings",
  },
];

export const goEasyBookingsNavigation = [
  {
    icon: Images.landFreightIcon,
    title: "Moving",
    link: "/go-easy/moving-bookings",
  },
  {
    icon: Images.landFreightIcon,
    title: "Cars",
    link: "/go-easy/car-bookings",
  },
  {
    icon: Images.landFreightIcon,
    title: "Transit",
    link: "/go-easy/transit-bookings",
  },
];
